import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "appearance"];
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React from "react";
import { useFocusMode } from "../../components/focusMode";
import { BaseButton } from "./BaseButton";
export var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? "button" : _ref$type,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? "primary" : _ref$appearance,
    props = _objectWithoutProperties(_ref, _excluded);
  if (process.env.NODE_ENV !== "production") {
    if (!props.children && (props.iconBefore || props.iconAfter) && !props["aria-label"] && !props["aria-labelledby"]) {
      console.warn("No aria-label or aria-labelledby provided to ICON-ONLY BUTTON component!");
    }
  }
  var _useFocusMode = useFocusMode({
      isDisabled: appearance !== "borderless"
    }),
    focusMode = _useFocusMode.focusMode;
  return jsx(BaseButton, _extends({}, props, {
    appearance: appearance,
    type: type,
    innerRef: ref,
    focusMode: focusMode,
    renderAs: "button"
  }));
});
//# sourceMappingURL=Button.js.map